import React from 'react'

import './SkeletonLoader.scss'

export const SkeletonLoader = () => {
	return (
		<div id="skeleton-loader">
			<span className="loading-block" />
		</div>
	)
}
